import { render, staticRenderFns } from "./TerminalContact.vue?vue&type=template&id=5416b2b2"
import script from "./terminalContact.ts?vue&type=script&lang=js&external"
export * from "./terminalContact.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports